// lib
import isEmpty from 'lodash/isEmpty';

// helpers
import { getRandomNumber } from 'shared/components/VisitorPriortization/helpers/helpers';

// constants
import { DEFAULT_BANNER_WIDGET_INDEX } from './constant';

// types
import { IBannerWidget, IWidgetObject, IMwebWidgetType, IWidgetConfig } from './types';

export const getUserSegment = (weightage: number | string) => {
  let bannerWidgetNumber: string | null = window.sessionStorage.getItem('bannerWidgetNumber');

  if (!bannerWidgetNumber) {
    bannerWidgetNumber = String(getRandomNumber());
    window.sessionStorage.setItem('bannerWidgetNumber', bannerWidgetNumber);
  }

  if (bannerWidgetNumber <= weightage) {
    return true;
  }

  return false;
};

export const isPDPBannerWidgetDisplayed = (
  bannerWidgetConfig: IBannerWidget,
  isMobile: boolean
) => {
  const { enable, weightage } = bannerWidgetConfig;

  const userSegment = getUserSegment(weightage);

  if (!enable || !userSegment || !isMobile) {
    return false;
  }

  return true;
};

export const getTransformedWidgetData = (
  widgetResponse: IWidgetObject,
  isMobile: boolean,
  bannerWidgetConfig: IBannerWidget,
  bannerIndex: number
) => {
  const isPDPBannerDisplayed = isPDPBannerWidgetDisplayed(bannerWidgetConfig, isMobile);

  if (!isPDPBannerDisplayed) {
    return widgetResponse;
  }

  let modifiedWidgetReponse = {
    relatedProducts: [],
  };

  const noOfWidgets = widgetResponse.relatedProducts.length;

  // if banner index within the response length
  for (let index = 0; index < noOfWidgets; index++) {
    const currentWidget = widgetResponse.relatedProducts[index];
    if (index === bannerIndex) {
      modifiedWidgetReponse.relatedProducts.push(bannerWidgetConfig);
    }
    modifiedWidgetReponse.relatedProducts.push(currentWidget);
  }

  // if banner index is out of bound
  if (bannerIndex >= noOfWidgets) {
    modifiedWidgetReponse.relatedProducts.push(bannerWidgetConfig);
  }

  return modifiedWidgetReponse;
};

export const getBannerConfig = (widgetConfig: IWidgetConfig) => {
  let bannerIndex = DEFAULT_BANNER_WIDGET_INDEX;
  let bannerWidgetConfig;

  const widgetConfigArray = widgetConfig;

  const bannerWidgetConfigArray = widgetConfigArray.filter(
    (widget: IMwebWidgetType, index: number) => {
      if (widget['pdp_banner_widget']) {
        bannerIndex = index;
        return true;
      }
      return false;
    }
  );

  if (!isEmpty(bannerWidgetConfigArray)) {
    bannerWidgetConfig = bannerWidgetConfigArray[0]['pdp_banner_widget'];
  }

  return {
    bannerIndex,
    bannerWidgetConfig,
  };
};
